import { render, staticRenderFns } from "./StatusCard.global.vue?vue&type=template&id=702eba42&scoped=true&lang=pug&"
import script from "./StatusCard.global.vue?vue&type=script&lang=ts&"
export * from "./StatusCard.global.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCard.global.vue?vue&type=style&index=0&id=702eba42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702eba42",
  null
  
)

export default component.exports